import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import Paragraph from '../../../../Typography/Paragraph/Paragraph';
import styles from './TrackInfoBlock.module.scss';
import cn from 'classnames';
import { firstLetterUpperCase } from '../../../../../helpers';
const TrackInfoBlock = ({ raceInfo }) => {
    const renderRequirements = () => {
        if (!raceInfo.requirements) {
            return null;
        }
        return Object.entries(raceInfo.requirements).map((it, index) => (_jsxs(Fragment, { children: [_jsx("div", { className: styles.dot }), _jsx(Paragraph, { title: `${firstLetterUpperCase(it[0])} ${it[1]}`, color: 'grey', size: 1, fontFamily: 'urbanist' })] }, index)));
    };
    return (_jsxs("div", Object.assign({ className: cn('d-flex align-items-center', styles.element) }, { children: [_jsx(Paragraph, { title: raceInfo.location, color: 'grey', size: 1, fontFamily: 'urbanist' }), renderRequirements(), _jsx("div", { className: styles.dot }), _jsx(Paragraph, { title: `${raceInfo.trackDetails.distance}m`, color: 'grey', size: 1, fontFamily: 'urbanist' })] })));
};
export default TrackInfoBlock;
